import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSingleDate_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template';
import {transactionsComparison_template} from './transactionsComparison_template'

declare var ko: any;

export class transactionsDelete_template extends vnTemplate{

    public datePicker : filterSingleDate_template;
    public comparisonTransactions: transactionsComparison_template;

    protected getTemplateHtml(): string{

        return `<div class="form-header">
                   <h3 class="form-title icon i-transaction">Delete Transaction</h3>

                </div>
                
                ` + this.comparisonTransactions.getHtmlBuild() + `
                
                <div class="form-group row">
                    <label for="singleDatePicker" class="form-label">schedule date</label>
                    ` + this.datePicker.getHtmlBuild() + `
                </div>
                
                <div class="form-footer">
                    <button data-bind="event: { click: onClickCancel }" class="btn" type="button">Cancel</button>
                    <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Delete</button>
                </div>
            `;
    }
    protected initPartial(): void {
        this.datePicker = new filterSingleDate_template("filterDate", this.getTemplateViewModel(), this.caller);

        this.datePicker.getTemplateViewModel().isPickerDisabled(true);

        this.comparisonTransactions = new transactionsComparison_template("reverseComparisonTransactions", this.getTemplateViewModel(), this.caller);
    }

    public buildDatePickerCalendar(){
        this.datePicker.buildCalendar();
    }

    protected getTemplateName(): string{
        return "transactionsDelete-form-template";
    }

    protected getMainElementClasses(): Array<string>{
        return ["w-form"];
    }

    protected buildViewModel(): any{

        let self = this;
        return  {
            id: ko.observable(""),
            amount: ko.observable(""),
            name: ko.observable(""),
            idStatus: ko.observable(),
            idType: ko.observable(),
            idCurrency: ko.observable(),
            idActionType: ko.observable(),
            idCreationType: ko.observable(),
            idEntryType: ko.observable(),
            idYoutube: ko.observable(""),
            idUser: ko.observable(),
            idTransactionLinked: ko.observable(),
            onClickSave: function(data, event){ self.onClickSave(); },
            onClickCancel: function(data, event){ self.onClickCancel(); }
        };
    }

    public setComparisonTransactions(trx, reverseTrx, data){
        //console.log(trx);
        this.comparisonTransactions.setOriginalTrx(trx, data);
        this.comparisonTransactions.setReverseTrx(reverseTrx, data);
    }

    public showComparisonTrx(){
        this.comparisonTransactions.showComparison();
    }

    public showReversalTrx() {
        this.comparisonTransactions.showReversal();
    }

    public setReverseTrxData(data){
        this.getTemplateViewModel().amount(data.transaction.amount);
        this.getTemplateViewModel().name(data.transaction.name + ' - (REVERSE)');
        this.getTemplateViewModel().idStatus(data.status.id);
        this.getTemplateViewModel().idCurrency(data.transaction.idCurrency);
        this.getTemplateViewModel().idActionType(data.actionType.id);
        this.getTemplateViewModel().idType(data.transaction.idType);
        this.getTemplateViewModel().idCreationType(data.creationType.id);
        this.getTemplateViewModel().idEntryType(data.entryType.id);
        this.getTemplateViewModel().idYoutube(data.project.idYoutube);
        this.getTemplateViewModel().idUser(data.user.id);
        this.getTemplateViewModel().idTransactionLinked(data.transaction.id);
    }
    //
    // save button function
    //
    protected onClickSave(){
        this.caller.saveEditTransaction();
    }

    //
    // cancel button function
    //
    protected onClickCancel(){
        this.caller.cancelEditTransaction();
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/transactionsDelete_template.ts